import { PurchaseOrder } from "~/types/user";

export const purchaseOrders: PurchaseOrder[] = [
  {
    id: "PO-001-2023",
    clientId: "1",
    clientName: "Petrobras Distribution",
    sellerId: "2",
    sellerName: "Sales Rep",
    deliveryAddress: "Av. República do Chile, 65 - Centro, Rio de Janeiro",
    items: [
      {
        productId: "1",
        productName: "Premium Motor Oil",
        quantity: 500,
        pricePerUnit: 120,
      },
      {
        productId: "3",
        productName: "Synthetic Transmission Oil",
        quantity: 200,
        pricePerUnit: 150,
      },
    ],
    total: 90000,
    status: "approved",
    createdAt: "2023-08-10",
    paymentStatus: "cleared",
  },
  {
    id: "PO-002-2023",
    clientId: "2",
    clientName: "Shell Retailers",
    sellerId: "2",
    sellerName: "Sales Rep",
    deliveryAddress: "Carel van Bylandtlaan 30, The Hague, Netherlands",
    items: [
      {
        productId: "4",
        productName: "Heavy-Duty Diesel Engine Oil",
        quantity: 350,
        pricePerUnit: 130,
      },
    ],
    total: 45500,
    status: "pending_approval",
    createdAt: "2023-08-12",
  },
  {
    id: "PO-003-2023",
    clientId: "5",
    clientName: "BP Retail Solutions",
    sellerId: "2",
    sellerName: "Sales Rep",
    deliveryAddress: "1 St James's Square, London, United Kingdom",
    items: [
      {
        productId: "2",
        productName: "Industrial Hydraulic Fluid",
        quantity: 400,
        pricePerUnit: 95,
      },
      {
        productId: "7",
        productName: "Gear Oil",
        quantity: 150,
        pricePerUnit: 115,
      },
    ],
    total: 55250,
    status: "rejected",
    createdAt: "2023-08-05",
    rejectionReason: "Credit limit exceeded for this client.",
  },
  {
    id: "PO-004-2023",
    clientId: "3",
    clientName: "ExxonMobil Supplies",
    sellerId: "2",
    sellerName: "Sales Rep",
    deliveryAddress: "5959 Las Colinas Boulevard, Irving, Texas",
    items: [
      {
        productId: "5",
        productName: "Marine Lubricant",
        quantity: 250,
        pricePerUnit: 170,
      },
      {
        productId: "6",
        productName: "Aviation Turbine Oil",
        quantity: 100,
        pricePerUnit: 230,
      },
    ],
    total: 65500,
    status: "approved",
    createdAt: "2023-08-08",
    paymentStatus: "pending",
  },
  {
    id: "PO-005-2023",
    clientId: "8",
    clientName: "Eni Global Markets",
    sellerId: "2",
    sellerName: "Sales Rep",
    deliveryAddress: "Piazzale Enrico Mattei, 1, Rome, Italy",
    items: [
      {
        productId: "1",
        productName: "Premium Motor Oil",
        quantity: 300,
        pricePerUnit: 120,
      },
      {
        productId: "8",
        productName: "Compressor Oil",
        quantity: 150,
        pricePerUnit: 145,
      },
    ],
    total: 57750,
    status: "approved",
    createdAt: "2023-07-28",
    paymentStatus: "late",
  },
  {
    id: "PO-006-2023",
    clientId: "10",
    clientName: "Marathon Petroleum",
    sellerId: "2",
    sellerName: "Sales Rep",
    deliveryAddress: "539 South Main Street, Findlay, Ohio",
    items: [
      {
        productId: "4",
        productName: "Heavy-Duty Diesel Engine Oil",
        quantity: 450,
        pricePerUnit: 130,
      },
    ],
    total: 58500,
    status: "pending_approval",
    createdAt: "2023-08-14",
  },
  {
    id: "PO-007-2023",
    clientId: "4",
    clientName: "Chevron Distributors",
    sellerId: "2",
    sellerName: "Sales Rep",
    deliveryAddress: "6001 Bollinger Canyon Road, San Ramon, California",
    items: [
      {
        productId: "3",
        productName: "Synthetic Transmission Oil",
        quantity: 320,
        pricePerUnit: 150,
      },
      {
        productId: "7",
        productName: "Gear Oil",
        quantity: 180,
        pricePerUnit: 115,
      },
    ],
    total: 68700,
    status: "pending_approval",
    createdAt: "2023-08-15",
  },
  {
    id: "PO-008-2023",
    clientId: "6",
    clientName: "TotalEnergies Marketing",
    sellerId: "2",
    sellerName: "Sales Rep",
    deliveryAddress: "2 Place Jean Millier, La Défense, France",
    items: [
      {
        productId: "1",
        productName: "Premium Motor Oil",
        quantity: 420,
        pricePerUnit: 120,
      },
    ],
    total: 50400,
    status: "approved",
    createdAt: "2023-08-09",
    paymentStatus: "pending",
  },
  {
    id: "PO-009-2023",
    clientId: "7",
    clientName: "ConocoPhillips Ventures",
    sellerId: "2",
    sellerName: "Sales Rep",
    deliveryAddress: "925 N. Eldridge Parkway, Houston, Texas",
    items: [
      {
        productId: "5",
        productName: "Marine Lubricant",
        quantity: 180,
        pricePerUnit: 170,
      },
    ],
    total: 30600,
    status: "rejected",
    createdAt: "2023-08-07",
    rejectionReason: "Invalid product specifications.",
  },
  {
    id: "PO-010-2023",
    clientId: "9",
    clientName: "Valero Refining",
    sellerId: "2",
    sellerName: "Sales Rep",
    deliveryAddress: "One Valero Way, San Antonio, Texas",
    items: [
      {
        productId: "2",
        productName: "Industrial Hydraulic Fluid",
        quantity: 560,
        pricePerUnit: 95,
      },
      {
        productId: "4",
        productName: "Heavy-Duty Diesel Engine Oil",
        quantity: 280,
        pricePerUnit: 130,
      },
    ],
    total: 89200,
    status: "approved",
    createdAt: "2023-08-05",
    paymentStatus: "cleared",
  },
  {
    id: "PO-011-2023",
    clientId: "11",
    clientName: "Phillips 66 Outlets",
    sellerId: "2",
    sellerName: "Sales Rep",
    deliveryAddress: "2331 CityWest Blvd, Houston, Texas",
    items: [
      {
        productId: "6",
        productName: "Aviation Turbine Oil",
        quantity: 150,
        pricePerUnit: 230,
      },
    ],
    total: 34500,
    status: "pending_approval",
    createdAt: "2023-08-16",
  },
  {
    id: "PO-012-2023",
    clientId: "12",
    clientName: "Repsol Distribution",
    sellerId: "2",
    sellerName: "Sales Rep",
    deliveryAddress: "C. de Méndez Álvaro, 44, Madrid, Spain",
    items: [
      {
        productId: "8",
        productName: "Compressor Oil",
        quantity: 220,
        pricePerUnit: 145,
      },
      {
        productId: "1",
        productName: "Premium Motor Oil",
        quantity: 180,
        pricePerUnit: 120,
      },
    ],
    total: 53900,
    status: "approved",
    createdAt: "2023-08-04",
    paymentStatus: "late",
  },
  {
    id: "PO-013-2023",
    clientId: "13",
    clientName: "Sinopec International",
    sellerId: "2",
    sellerName: "Sales Rep",
    deliveryAddress: "22 Chaoyangmen North Street, Beijing, China",
    items: [
      {
        productId: "3",
        productName: "Synthetic Transmission Oil",
        quantity: 380,
        pricePerUnit: 150,
      },
    ],
    total: 57000,
    status: "approved",
    createdAt: "2023-08-03",
    paymentStatus: "cleared",
  },
];
